import $ from "jquery";

require('tooltipster');

const Dictionary = (() => {
  return {
    initialize: (selector) => {
      if(typeof EASY_DICTIONARY === 'undefined') {
        return;
      }

      const $element = $(selector);
      const $elements = $element.find('*:not(.dictionary-tooltip)');

      for(let i = 0; i < EASY_DICTIONARY.length; i++) {
        const entry = EASY_DICTIONARY[i];
        const regex = new RegExp('('+entry.expression+')', 'ig');
        const desc = $('<div/>').text(entry.description).html();
        $elements.each(function(index, element) {
          const $el = $(element);
          const text = $el.text();
          if(typeof text !== 'undefined' && text !== null && text.trim().length > 0) {
            $el.html($el.html().replace(regex, '<span class="dictionary-tooltip" title="'+desc+'">$1</span>'));
          }
        });
      }

      $('.dictionary-tooltip').tooltipster({
        contentAsHTML: true,
      });
    },
  };
})();

module.exports = Dictionary;
